<template>
  <section class="page-otcAccount">
    <div class="otcAccount-header-bg">
      <div class="otcAccount-header" :style="otcHeader">
        <div class="otcAccount-header-bar">
          <!-- 资产折合 -->
          <ul class="assetsSum b-8-cl">
            <!-- 总资产折合 -->
            <li class="text">{{ $t("assets.otcAccount.TotalAssets") }}</li>
            <li class="num">
              {{ totalBalance }}<span>{{ totalBalanceSymbol }}</span>
            </li>
            <li class="conversion">≈ {{ totalRate }}</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="otcAccount-body main-second-bg">
      <div class="otcAccount-title a-3-bd">
        <!-- 资金列表 -->
        <div class="text b-1-cl">{{ $t("assets.otcAccount.ListOfFunds") }}</div>
        <div class="operate">
          <div class="find">
            <!-- 搜索币种 -->
            <c-inputFind
              :promptText="$t('assets.otcAccount.SearchCurrency')"
              :value="findValue"
              @onchanges="findChanges"
              className="findClass"
              newStyleFormat
            />
          </div>
          <div class="hide">
            <!-- 隐藏零资产 -->
            <c-checkBox :value="switchFlag" @click="switchChange" />
            <span class="hodetext">{{ $t("assets.hideMinAssets") }}</span>
          </div>
        </div>
      </div>
      <div class="otcAccount-center">
        <c-table
          :imgMap="imgMap"
          :colorMap="colorMap"
          :loading="tabelLoading"
          @elementClick="tableClick"
          :columns="columns"
          :dataList="dataListFilter"
          :cellHeight="55"
        />
      </div>
      <CommonTransfer ref="CommonTransfer" @success="sendOtcAxios"></CommonTransfer>
    </div>
  </section>
</template>
<script>
import {
  myStorage, fixD, fixRate, colorMap, imgMap, getCoinShowName,
} from '@/utils';
import zcLogoBg from '@/assets/img/zc-logo-bg.png';
import CommonTransfer from '@/views/components/CommonTransfer.vue';

const defaultIcon = imgMap.f_1;

export default {
  name: 'page-otcAccount',
  components: {
    CommonTransfer,
  },
  data() {
    return {
      otcHeader: `background: url(${zcLogoBg});background-size: cover;`,
      imgMap,
      colorMap,
      tabelLoading: true, // 表格 loading
      dataList: [], // 表格 数据
      totalBalance: '--', // 资产折合
      totalBalanceSymbol: '', // 资产折合币种
      totalRate: '--', // 资产折合汇率
      switchFlag: false, // 是否隐藏零资产
      findValue: '', // 搜索币种
    };
  },
  computed: {
    // 表格title
    columns() {
      return [
        { title: this.$t('assets.otcAccount.coin'), width: '30%' }, // 币种
        { title: this.$t('assets.otcAccount.Available'), width: '30%' }, // 可用
        { title: this.$t('assets.otcAccount.freeze'), width: '20%' }, // 冻结
        { title: this.$t('assets.otcAccount.options'), width: '20%' }, // 操作
      ];
    },
    market() {
      return this.$store.state.baseData.market;
    },
    // 资金列表展示到页面数据
    dataListFilter() {
      // 隐藏零资产功能过滤数据
      let list = [];
      if (this.switchFlag) {
        this.dataList.forEach((item) => {
          if (parseFloat(item.btcValuation) >= 0.0001) {
            list.push(item);
          }
        });
      } else {
        list = this.dataList;
      }
      // 搜索框功能过滤数据
      const newList = [];
      list.forEach((item) => {
        if (item.data[0][1].text.toUpperCase().indexOf(this.findValue.toUpperCase()) !== -1) {
          newList.push(item);
        }
      });
      return newList;
    },
  },
  watch: {
    market(v) {
      if (v) {
        this.sendOtcAxios();
      }
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (myStorage.get('assetsSwitch')) {
        this.switchFlag = myStorage.get('assetsSwitch');
      }
      if (this.market) {
        this.sendOtcAxios();
      }
    },
    // 获取列表
    sendOtcAxios() {
      this.axios({
        url: 'finance/v4/otc_account_list',
      }).then((data) => {
        this.tabelLoading = false;
        if (data.code.toString() === '0') {
          this.setData(data.data);
        } else {
          this.$bus.$emit('tip', { text: data.msg, type: 'error' });
        }
      });
    },
    // 处理列表数据
    setData({ totalBalance, totalBalanceSymbol, allCoinMap }) {
      const { coinList, rate } = this.market;
      const FFix = (coinList[totalBalanceSymbol] && coinList[totalBalanceSymbol].showPrecision) || 0;
      this.totalBalance = fixD(totalBalance, FFix); // 折合资产
      this.totalBalanceSymbol = totalBalanceSymbol; // 折合币种
      this.totalRate = fixRate(totalBalance, rate, totalBalanceSymbol); // 折合法币
      const btcFix = (coinList[totalBalanceSymbol] && coinList[totalBalanceSymbol].showPrecision) || 0;
      const list = [];
      allCoinMap.forEach((item) => {
        const fix = (coinList[item.coinSymbol] && coinList[item.coinSymbol].showPrecision) || 0;
        let coinImg = defaultIcon;
        if (coinList[item.coinSymbol] && coinList[item.coinSymbol].icon.length) {
          coinImg = coinList[item.coinSymbol].icon;
        }
        list.push({
          id: JSON.stringify(item),
          btcValuation: fixD(item.btcValuation, btcFix),
          data: [
            [
              {
                type: 'icon', // 'link' ' button' ,'html', 'label', 'icon' ‘str’
                iconSvg: `<div class="coinIcon"><img src="${coinImg}"/></div>`,
                eventType: 'goTradeIn',
                classes: ['coinBox'],
              },
              {
                text: getCoinShowName(item.coinSymbol, coinList),
              },
            ],
            fixD(item.normal, fix),
            fixD(item.lock, fix),
            [
              {
                type: 'button', // 'link' ' button' ,'html', 'label', 'icon' ‘str’
                text: this.$t('assets.otcAccount.optionCapitalTransfer'), // 资金划转
                eventType: 'transfer',
                classes: ['coinButton'],
              },
            ],
          ],
        });
      });
      this.dataList = list;
    },
    // 隐藏零资产
    findChanges(v) {
      this.findValue = v;
    },
    switchChange() {
      this.switchFlag = !this.switchFlag;
      myStorage.set('assetsSwitch', this.switchFlag);
    },
    tableClick(type, data) {
      if (type === 'transfer') {
        const transferObj = JSON.parse(data);
        this.$refs.CommonTransfer.show(transferObj.coinSymbol, true, 'otc');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page-otcAccount {
  position: relative;
  width: 100%;
  height: 100%;
  /deep/ .table-body-bar {
    .coinBox {
      display: inline-block;
      height: 55px;
      position: relative;
      margin-left: 0 !important;
      width: 58px;
      .coinIcon {
        position: absolute;
        height: 55px;
        // padding-top: 5px;
        width: 100%;
        top: 1px;
        img {
          position: absolute;
          top: 12px;
          width: 28px;
          height: 28px;
        }
      }
    }
    tr:last-child {
      border-bottom-style: solid;
      border-bottom-width: 1px;
    }
    .coinButton {
      padding-left: 0 !important;
    }
  }
  .switchWrap {
    display: inline-block;
  }
  .otcAccount-header {
    width: 100%;
    height: 140px;
    padding: 20px;
    box-sizing: border-box;
    .canvasBox {
      width: 100px;
      height: 100px;
      float: left;
    }
    .assetsSum {
      float: left;
      margin-left: 20px;
      .text {
        font-size: 12px;
        letter-spacing: 0;
        line-height: 12px;
        margin-top: 12px;
        opacity: 0.6;
      }
      .num {
        margin-top: 12px;
        font-size: 32px;
        letter-spacing: 0;
        line-height: 28px;
        span {
          font-size: 14px;
          line-height: 12px;
          margin-left: 3px;
          opacity: 0.6;
        }
      }
      .conversion {
        margin-top: 12px;
        font-size: 14px;
        line-height: 12px;
        opacity: 0.6;
      }
    }
    .colorList {
      float: left;
      width: 240px;
      margin-left: 40px;
      margin-top: 10px;
      li {
        float: left;
        width: 80px;
        font-size: 12px;
        margin-top: 20px;
        line-height: 14px;
        span {
          display: inline-block;
          width: 14px;
          height: 14px;
          border-radius: 2px;
          margin-right: 10px;
        }
      }
    }
  }
  .otcAccount-body {
    margin-top: 24px;
    min-height: 636px;
    border-radius: 6px;
  }
  .otcAccount-title {
    height: 55px;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    padding: 0 20px;
    vertical-align: middle;

    .text {
      float: left;
      font-size: 14px;
      vertical-align: middle;
      display: inline-block;
      line-height: 55px;
    }

    .operate {
      float: right;
      display: flex;
      align-items: center;
      gap: 25px;

      .hide {
        vertical-align: middle;
        display: inline-block;
        line-height: 55px;
        .hodetext {
          margin-left: 8px;
          font-size: 12px;
        }
      }
      .find {
        float: right;
        vertical-align: middle;
        display: inline-block;
        width: 214px;
      }
    }
  }
  .otcAccount-center {
    width: 100%;
    box-sizing: border-box;
    .table-head,
    .table-body-bar {
      padding: 0 !important;
    }
  }
  .otcAccount-header-bg {
    background-image: linear-gradient(-269deg, #5545e0 0%, #294ebb 100%);
    border-radius: 6px;
    overflow: hidden;
  }
  .otcAccount-header {
    background-position: right bottom !important;
    background-repeat: no-repeat !important;
  }
}
</style>
